import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";

interface ListingsTableHeaderProps {
  onSelectAll: () => void;
  allSelected: boolean;
  hasListings: boolean;
}

export function ListingsTableHeader({
  onSelectAll,
  allSelected,
  hasListings,
}: ListingsTableHeaderProps) {
  return (
    <TableHeader>
      <TableRow>
        <TableHead className="w-12">
          <Checkbox
            checked={hasListings && allSelected}
            onCheckedChange={onSelectAll}
            disabled={!hasListings}
          />
        </TableHead>
        <TableHead className="w-12">ID</TableHead>
        <TableHead>Title</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Owner</TableHead>
        <TableHead>Location</TableHead>
        <TableHead>Price</TableHead>
        <TableHead>Created</TableHead>
        <TableHead>Featured</TableHead>
        <TableHead>Actions</TableHead>
      </TableRow>
    </TableHeader>
  );
}
